/**
 * AI 模型配置列表
 * @property {string} name - AI 模型名称
 * @property {number} number - AI 模型编号
 * @property {string} label - AI 模型标签
 */
export const AI_MODEL_LIST = [{
        name: 'ChatGPT',
        number: 0,
        value: 'yiwen',
        label: 'AI易问',
        type: 'text'
    },
    {
        name: '文心2.0（ERNIE2.0）',
        number: 1,
        value: 'yiyan',
        label: 'AI易言',
        type: 'text'
    },
    {
        name: '文心一格',
        number: 2,
        value: 'yihua',
        label: 'AI易画',
        type: 'image'
    },
    {
        name: '通义千问',
        number: 3,
        value: 'zixun',
        label: 'AI易写',
        type: 'text'
    },
    {
        name: 'OCR图片识别',
        number: 4,
        value: 'yilu',
        label: 'ocr'
    },
    {
        name: 'DeepSeek 671B',
        number: 5,
        value: 'dx-deepseek671b',
        label: 'dx-deepseek671b'
    },
    {
        name: 'DeepSeek R1深度思考',
        number: 6,
        value: 'deepseek-reasoner',
        label: 'deepseek-reasoner',
        type: 'text'
    },
    {
        name: 'DeepSeek V3',
        number: 7,
        value: 'deepseek-chat',
        label: 'deepseek-chat',
        type: 'text'
    },
    {
        name: 'DeepSeek V4快速',
        number: 11,
        value: 'deepseek-v4-flash',
        label: 'deepseek-v4-flash',
        type: 'text'
    },
    {
        name: 'DeepSeek V4专家',
        number: 12,
        value: 'deepseek-v4-pro',
        label: 'deepseek-v4-pro',
        type: 'text'
    },
    {
        name: 'Doubao-seed-2.0-pro',
        number: 10,
        value: 'doubao-text',
        label: 'doubao-text',
        type: 'text'
    },
    {
        name: '豆包图片生成',
        number: 8,
        value: 'doubao-image',
        label: 'doubao-image',
        type: 'image'
    },
    {
        name: '豆包视频生成',
        number: 9,
        value: 'doubao-video',
        label: 'doubao-video',
        type: 'video'
    },
    {
        name: 'Nano Banana gemini-3.1-flash',
        number: 13,
        value: 'gemini-3.1-flash',
        label: 'gemini-3.1-flash',
        type: 'image'
    },
    {
        name: 'Nano Banana gemini-3-pro',
        number: 14,
        value: 'gemini-3-pro',
        label: 'gemini-3-pro',
        type: 'image'
    },
    {
        name: 'claude-extra',
        number: 15,
        value: 'claude-opus-4-7',
        label: 'claude-opus-4-7',
        type: 'text'
    },
    {
        name: 'codex gpt-5.4',
        number: 16,
        value: 'gpt-5.4',
        label: 'gpt-5.4',
        type: 'text'
    },
    {
        name: 'codex gpt-5.5',
        number: 17,
        value: 'gpt-5.5',
        label: 'gpt-5.5',
        type: 'text'
    },
    {
        name: 'Gemini3文本',
        number: 18,
        value: 'gemini-3.1-pro-preview',
        label: 'gemini-3.1-pro-preview',
        type: 'text'
    },
    {
        name: 'OpenAI画图',
        number: 19,
        value: 'gpt-image-2',
        label: 'gpt-image-2',
        type: 'image'
    }
]